'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ChatIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ChatIcon">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="Messages-Bubble-Square--Streamline-Ultimate" height="24" width="24">
        <desc>
          Messages Bubble Square Streamline Icon: https://streamlinehq.com
        </desc>
        <path d="M23.5 17a1 1 0 0 1 -1 1h-11l-4 4v-4h-6a1 1 0 0 1 -1 -1V3a1 1 0 0 1 1 -1h21a1 1 0 0 1 1 1Z" fill="none" stroke="#3d517b8f" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"></path>
      </svg>
    </SvgIcon>
  )
}

ChatIcon.propTypes = {
  sx: PropTypes.object
}
